import { template as template_591656113fd04c1cbf1bbb43d34cb193 } from "@ember/template-compiler";
import { isPresent } from '@ember/utils';
const getOptionsWithDefault = (options, displayedField, defaultOption)=>{
    if (isPresent(defaultOption)) {
        return [
            {
                isDefaultOption: true,
                [displayedField]: defaultOption
            },
            ...options
        ];
    }
    return options;
};
const getSelectedOption = (selected, optionsWithDefault)=>{
    if (selected == null) {
        return optionsWithDefault[0];
    } else {
        return selected;
    }
};
export default template_591656113fd04c1cbf1bbb43d34cb193(`
{{#let (getOptionsWithDefault @options @displayedField @defaultOption) as |optionsWithDefault|}}
  {{yield
    optionsWithDefault
    (getSelectedOption @selected optionsWithDefault)
  }}
{{/let}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
